import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import * as moment from 'moment';
import { UntypedFormBuilder, UntypedFormControl } from '@angular/forms';
import { SelectionGenericService } from 'app/modules/selection-generic/services/selection-generic.service';
import { DateAdapter } from '@angular/material/core';
import { DateFilterTypes } from 'app/modules/common/enums/date-filter-enums';
import { requiredValidator } from 'app/modules/common/validation/common-validation';
import { SharedService } from 'app/modules/common/services/shared-service';

@Component({
    selector: 'app-date-period-selector',
    templateUrl: './date-period-selector.component.html',
    styleUrls: ['./date-period-selector.component.scss'],
    standalone: false
})
export class DatePeriodSelectorComponent implements OnInit {


    datePeriodTitle = '';

    @Input("required-error-message") requiredErrorMsg = "Se requiere valor";

    @Input() PeriodFrom: UntypedFormControl;
    @Input() PeriodTo: UntypedFormControl;

    @Input() DateType: DateFilterTypes;
    @Input() IsBothDatesRequired = false;
    @Output() FromDateChanged = new EventEmitter();
    @Output() ToDateChanged = new EventEmitter();

    months = ['Enero', 'Febrero', 'Marzo', 'Abril', 'Mayo', 'Junio', 'Julio', 'Agosto', 'Septiembre', 'Octubre', 'Noviembre', 'Diciembre'];

    calendarDayOptions: any[];
    calendarWeekOptions: any[];

    calendarMonthOptions: any[];
    calendarLastYearMonthOptions = [];
    calendarThisYearMonthOptions = [];

    calendarTermOptions: any[];
    calendarYearOptions: any[];

    public maxDate = null;
    public minDate = null;

    constructor(
        private formBuilder: UntypedFormBuilder, private selectionService: SelectionGenericService,
        private dateAdapter: DateAdapter<any>, public sharedService: SharedService) { }

    public ngOnInit(): void {
        this.setTitleAndDefaultValues();
        this.setValidation();
        moment.locale('es');
        this.dateAdapter.setLocale('es');
        this.calendarDayOptions = [
            { text: 'Ayer - ', start: moment().subtract(1, 'day').format('ddd DD/MM/YYYY'), end: moment().subtract(1, 'day').format('ddd DD/MM/YYYY') },
            { text: 'Hoy - ', start: moment().format('ddd DD/MM/YYYY'), end: moment().format('ddd DD/MM/YYYY') },
            { text: 'Mañana - ', start: moment().add(1, 'day').format('ddd DD/MM/YYYY'), end: moment().add(1, 'day').format('ddd DD/MM/YYYY') }
        ];

        this.calendarWeekOptions = [
            {
                text: 'Semana pasada - ',
                start: moment().subtract(1, 'week').startOf('isoWeek').format('ddd DD/MM/YYYY'),
                end: moment().subtract(1, 'week').endOf('isoWeek').format('ddd DD/MM/YYYY')
            },
            {
                text: 'Esta semana - ',
                start: moment().startOf('isoWeek').format('ddd DD/MM/YYYY'),
                end: moment().endOf('isoWeek').format('ddd DD/MM/YYYY')
            },
            {
                text: 'Próxima semana - ',
                start: moment().add(1, 'week').startOf('isoWeek').format('ddd DD/MM/YYYY'),
                end: moment().add(1, 'week').endOf('isoWeek').format('ddd DD/MM/YYYY')
            }
        ];

        this.calendarMonthOptions = [
            {
                text: 'Mes pasado - ',
                start: moment().subtract(1, 'month').startOf('month').format('ddd DD/MM/YYYY'),
                end: moment().subtract(1, 'month').endOf('month').format('ddd DD/MM/YYYY')
            },
            {
                text: 'Este mes - ',
                start: moment().startOf('month').format('ddd DD/MM/YYYY'),
                end: moment().endOf('month').format('ddd DD/MM/YYYY')
            },
            {
                text: 'Próximo mes - ',
                start: moment().add(1, 'month').startOf('month').format('ddd DD/MM/YYYY'),
                end: moment().add(1, 'month').endOf('month').format('ddd DD/MM/YYYY')
            }
        ];

        for (let month = 1; month < 13; month++) {
            let year = moment().year() - 1;
            let cuurentDate = '01/' + month + '/' + year;
            let momentDate = moment(cuurentDate, 'DD/MM/YYYY');

            this.calendarLastYearMonthOptions.push(
                {
                    text: this.months[month - 1] + ' - ',
                    start: momentDate.startOf('month').format('ddd DD/MM/YYYY'),
                    end: momentDate.endOf('month').format('ddd DD/MM/YYYY')
                }
            );

            year = moment().year();
            cuurentDate = '01/' + month + '/' + year;
            momentDate = moment(cuurentDate, 'DD/MM/YYYY');

            this.calendarThisYearMonthOptions.push(
                {
                    text: this.months[month - 1] + ' - ',
                    start: momentDate.startOf('month').format('ddd DD/MM/YYYY'),
                    end: momentDate.endOf('month').format('ddd DD/MM/YYYY')
                }
            );
        }

        this.calendarTermOptions = [
            {
                text: 'Trimestre pasado - ',
                start: moment().subtract(1, 'quarter').startOf('quarter').format('ddd DD/MM/YYYY'),
                end: moment().subtract(1, 'quarter').endOf('quarter').format('ddd DD/MM/YYYY')
            },
            {
                text: 'Este trimestre - ',
                start: moment().startOf('quarter').format('ddd DD/MM/YYYY'),
                end: moment().endOf('quarter').format('ddd DD/MM/YYYY')
            },
            {
                text: 'Próximo trimester - ',
                start: moment().add(1, 'quarter').startOf('quarter').format('ddd DD/MM/YYYY'),
                end: moment().add(1, 'quarter').endOf('quarter').format('ddd DD/MM/YYYY')
            }
        ];

        this.calendarYearOptions = [
            {
                text: 'Año pasado - ',
                start: moment().subtract(1, 'year').startOf('year').format('ddd DD/MM/YYYY'),
                end: moment().subtract(1, 'year').endOf('year').format('ddd DD/MM/YYYY')
            },
            {
                text: 'Este año - ',
                start: moment().startOf('year').format('ddd DD/MM/YYYY'),
                end: moment().endOf('year').format('ddd DD/MM/YYYY')
            },
            {
                text: 'Hasta el mes pasado - ',
                start: moment().startOf('year').format('ddd DD/MM/YYYY'),
                end: moment().subtract(1, 'month').endOf('month').format('ddd DD/MM/YYYY')
            }
        ];
    }

    setValidation(): void {
        if (this.IsBothDatesRequired) {
            this.PeriodFrom.valueChanges.subscribe(fromDate => {
                if (fromDate != null) {
                    this.PeriodTo.setValidators([requiredValidator()]);

                } else {
                    this.PeriodTo.setValidators(null);
                }

                this.PeriodTo.updateValueAndValidity({ emitEvent: false });
            });

            this.PeriodTo.valueChanges.subscribe(toDate => {
                if (toDate != null) {
                    this.PeriodFrom.setValidators([requiredValidator()]);

                } else {
                    this.PeriodFrom.setValidators(null);
                }

                this.PeriodFrom.updateValueAndValidity({ emitEvent: false });
            });
        }
    }

    setTitleAndDefaultValues(): void {
        let from = null;
        let to = null;
        switch (this.DateType) {
            case DateFilterTypes.FechaRevision:
                this.datePeriodTitle = 'Fecha Revisión';
                break;
            case DateFilterTypes.Registro:
                this.datePeriodTitle = 'Registro';
                break;
            case DateFilterTypes.Common:
                this.datePeriodTitle = 'Periodo';
                break;
            case DateFilterTypes.PeriodoDeBaja:
                this.datePeriodTitle = 'Periodo De Baja';
                break;

            case DateFilterTypes.Communication:
                this.datePeriodTitle = 'Avisos';
                if (this.sharedService.selectedSelectionTabId === 2) {
                    from = this.selectionService.leaveSelectionModal.CommunicationDateFrom === '' ? null : this.selectionService.leaveSelectionModal.CommunicationDateFrom;
                    to = this.selectionService.leaveSelectionModal.CommunicationDateTo === '' ? null : this.selectionService.leaveSelectionModal.CommunicationDateTo;
                    this.PeriodFrom.setValue(from);
                    this.PeriodTo.setValue(to);
                }

                break;

            case DateFilterTypes.Discharge:
                this.datePeriodTitle = 'Altas';
                if (this.sharedService.selectedSelectionTabId === 2) {
                    from = this.selectionService.leaveSelectionModal.DischargeDateFrom === '' ? null : this.selectionService.leaveSelectionModal.DischargeDateFrom;
                    to = this.selectionService.leaveSelectionModal.DischargeDateTo === '' ? null : this.selectionService.leaveSelectionModal.DischargeDateTo;
                    this.PeriodFrom.setValue(from);
                    this.PeriodTo.setValue(to);
                }

                break;

            case DateFilterTypes.NewLeave:
                this.datePeriodTitle = 'Bajas Nuevas';
                if (this.sharedService.selectedSelectionTabId === 2) {
                    from = this.selectionService.leaveSelectionModal.NewLeaveDateFrom === '' ? null : this.selectionService.leaveSelectionModal.NewLeaveDateFrom;
                    to = this.selectionService.leaveSelectionModal.NewLeaveDateTo === '' ? null : this.selectionService.leaveSelectionModal.NewLeaveDateTo;
                    this.PeriodFrom.setValue(from);
                    this.PeriodTo.setValue(to);
                }

                break;

            default:
                this.datePeriodTitle = '';
                break;
        }
    }

    setSelectedDate(dateOption: any): any {
        this.PeriodFrom.setValue(moment(dateOption.start, 'ddd DD/MM/YYYY'));
        this.PeriodTo.setValue(moment(dateOption.end, 'ddd DD/MM/YYYY'));

        this.setDateFilter('F');
        this.setDateFilter('T');
    }

    setDateFilter(inputType: string): any {
        if (inputType === 'F') {
            const fromValue = this.PeriodFrom.value;
            this.minDate = fromValue;
            if (this.PeriodFrom.value !== null) {
                this.FromDateChanged.emit(fromValue._d);
            } else {
                this.FromDateChanged.emit(fromValue);
            }

        } else {
            const toValue = this.PeriodTo.value;
            this.maxDate = toValue;
            if (toValue !== null) {
                this.ToDateChanged.emit(toValue._d);
            } else {
                this.ToDateChanged.emit(toValue);
            }
        }
    }

}
